import React from "react";

export type StatusBadgeVariant = "success" | "error" | "neutral";

interface StatusBadgeProps {
  children: React.ReactNode;
  variant?: StatusBadgeVariant;
  className?: string;
}

// Token-based so they adapt to light/dark (the /15 wash reads on any surface),
// matching the Badge component's success/error variants.
const variantClasses: Record<StatusBadgeVariant, string> = {
  success: "bg-success/15 text-success",
  error: "bg-destructive/15 text-destructive",
  neutral: "bg-muted text-muted-foreground",
};

/**
 * A compact badge for status or score display.
 * Uses custom styling (not DaisyUI) for consistency in detail views.
 */
export function StatusBadge({
  children,
  variant = "neutral",
  className = "",
}: StatusBadgeProps) {
  return (
    <span
      className={`text-xs font-bold px-2 py-0.5 rounded ${variantClasses[variant]} ${className}`}
    >
      {children}
    </span>
  );
}
